<template>
  <article class="search-result-page">
    <figure
      v-if="image"
      class="rounded-sm no-overflow"
      :class="
        contentType == 'Compliance/Certification'
        ? 'compliance-certification-logo bg-white'
        : 'responsive-image bg-gray-200'
      "
    >
      <img :src="image" alt="" />
    </figure>
    <div>
      <div class="mt-md md:mt-0 search-result-page--content-title">
        <span v-if="contentType" class="search-result-pill">
          {{ contentType }}
        </span>
        <h3 class="my-sm">
          <a :href="item.url" @click="sendEvent('click', item, 'Global Search Page Result Clicked')">
            <ais-highlight :hit="item" attribute="content_title" />
          </a>
        </h3>
      </div>
      <hit-description :item="item" class="text-base c-gray-800" />
    </div>
  </article>
</template>

<script>
import HitDescription from './HitDescription.vue';

export default {
  components: {
    'hit-description': HitDescription
  },
  props: ['item', 'sendEvent'],
  computed: {
    contentType() {
      const contentType = this.item.content_type;
      const conditions = [
        'Basic page',
        'Innovation Category',
        'Landing Page Level 1',
        'Landing Page Level 2',
        'Product Configurator'
      ];

      return !conditions.some(cond => contentType.includes(cond)) ? contentType : '';
    },
    image() {
      return this.item.content_image || this.item.content_featured_image;
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-page {
  display: flex;
  flex-direction: column;

  .compliance-certification-logo {
    min-height: 115px;
    max-height: 215.63px;

    @media (min-width: 1024px) {
      max-height: 115px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }

  @media (min-width: 1024px) {
    flex-direction: row;

    .search-result-pill {
      margin-top: 0;
    }
    figure {
      width: 33%;
      max-width: 190px;
      max-height: 115px;
      margin-right: 1.25em;
      flex-shrink: 0;
    }
    > div {
      display: flex;
      flex-direction: column;
    }
  }
}

.search-results--inspiration {
  .search-result-page--content-title {
    display: flex;
    flex-direction: column;
    align-content: center;

    @media (min-width: 1024px) {
      flex-direction: row;
      margin: 0 0 $space-sm 0;

      h3 {
        margin-left: $space-md;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
